module.exports = __webpack_public_path__ + "static/img/ability-img1.91b495d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/ability-img1.png
// module id = i4o+
// module chunks = 2